import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import loginImage from '../../assets/images/loginPage.jpg';

// import closeCircle from '../../assets/icons/close-circle.png';
// import closeErrorCircle from '../../assets/icons/close-icon.png';
import { CloseChartIcon, CloseIconAdvance } from './svgIcon';
import PreviewPortal from './preview';

function ModalBox(props) {
  const { headerStyle, style: customStyle } = props;
  // const [isHovered, setIsHovered] = useState(false); // State to track hover
  const animationKeyframes = `
      @keyframes slideInFromRight {
        from {
          transform: translate(100%, -50%);
          opacity: 0;
        }
        to {
          transform: translate(-50%, -50%);
          opacity: 1;
        }
      }
    `;
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '0.2px solid #bab8b8',
    boxShadow: 24,
    borderRadius: '10px',
    // p: 3,
    padding: props?.modalView?.paddingTop ? props?.modalView?.paddingTop : '18px 8px 18px 8px',
    paddingTop: props?.modalView?.paddingTop ? props?.modalView?.paddingTop : '24px',
    overflowY: 'scroll',
    // height: -webkit-fill-available,
    // animation: 'slideInFromRight 0.75s ease-in-out',
  };
  const rotation = props?.preview?.rotation ?? 0; // fallback to 0 if undefined
  const isVertical = rotation % 180 !== 0;
  return (
    <>
      <style>
        {animationKeyframes}
      </style>
      <Modal
        open={props?.status}
        onClose={() => props?.closeModal(false)} // Close immediately without animation
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, ...(customStyle || {}) }}>
          <div
            className="modal-box"
            style={{
              padding: props?.modalView?.headerIcon ? '10px' : '6px',
            }}
          >
            {!props?.from
              && (
                <div className="modal-header" style={headerStyle}>
                  {!props?.modalView?.headerIcon && (
                    <h1 className="modal-header-title" style={props?.modalView?.style}>{props?.modalView?.title}</h1>
                  )}
                  {props?.modalView?.headerIcon && (
                    <div className="modal-header-icon">{props?.modalView?.headerIcon}</div>
                  )}
                  {/* {!props?.notification
                && (
                  <div
                    id="close-modal"
                    role="presentation"
                    className="modal-close-button"
                    onClick={() => props?.closeModal()}
                  >
                    <img src={closeCircle} alt="sort" />
                  </div>
                )} */}
                  {/* 2 */}
                  {!props?.notification && (
                    // <div
                    //   id="close-modal"
                    //   role="presentation"
                    //   className="modal-close-button"
                    //   onClick={() => props?.closeModal(false)} // Close immediately without animation
                    //   onMouseEnter={() => setIsHovered(true)} // Set hover state to true
                    //   onMouseLeave={() => setIsHovered(false)} // Set hover state to false
                    // >
                    //   {/* Conditionally render the icon based on hover state */}
                    //   <img
                    //     src={isHovered ? closeErrorCircle : closeCircle}
                    //     alt="close"
                    //     style={{ cursor: 'pointer' }} // Optional: Add pointer cursor for better UX
                    //   />
                    // </div>
                    <div onClick={() => props?.closeModal(false)} role="none" className="close-modal">
                      <CloseChartIcon />
                    </div>
                  )}
                </div>
              )}
            <div
              className="modal-body"
              style={{
                width: '100%',
              }}
            >
              {props?.modalView?.content}
            </div>
          </div>
        </Box>
      </Modal>
      {props?.previewModel && (
        <PreviewPortal>
          <div className="preview-image-view">
            <span
              className="close-icon"
              role="presentation"
              onClick={() => props?.previewClose(false)}
            >
              <CloseIconAdvance />
            </span>
            <div
              className="image-render-container"
            >
              <img
                src={props?.preview?.imageUrl || loginImage}
                alt="preview"
                style={{
                  transform: `rotate(${props?.preview?.rotation}deg)`,
                  width: isVertical ? '48%' : '100%',
                  height: isVertical ? '207%' : '100%',
                  objectFit: 'cover',
                  borderRadius: '4px',
                }}
              />
            </div>
          </div>
        </PreviewPortal>
      )}
    </>
  );
}

ModalBox.propTypes = {
  headerStyle: PropTypes.shape({
    borderBottom: PropTypes.string, // Define the specific style props you expect
  }),
  status: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  previewClose: PropTypes.func,
  modalView: PropTypes.shape({
    title: PropTypes.string,
    style: PropTypes.objectOf(),
    content: PropTypes.node,
    paddingTop: PropTypes.string,
    headerIcon: PropTypes.element,
  }),
  notification: PropTypes.bool,
  previewModel: PropTypes.bool,
  preview: PropTypes.string,
  style: PropTypes.shape({
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  from: PropTypes.string.isRequired,
};
ModalBox.defaultProps = {
  headerStyle: {},
  notification: false,
  previewModel: false,
  previewClose: () => { },
  modalView: {},
  preview: '',
  style: {},
};

export default ModalBox;
